import { render, staticRenderFns } from "./RecordHistory.vue?vue&type=template&id=6796aba0&"
import script from "./RecordHistory.vue?vue&type=script&lang=js&"
export * from "./RecordHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports